import { createApp } from 'vue'
import App from './App.vue'
import './styles/index.css'
import router  from "@/routes/router";
import { store } from "@/store/store";
import { Amplify } from "aws-amplify";
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import awsConfig from './aws-exports';

Amplify.configure(awsConfig);

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: '.cruzcontrol.app',
    path: '/',
    expires: 365,
    sameSite: 'lax',
    secure: true
  })
);

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faEye, faInfoCircle } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faEye)
library.add(faInfoCircle)

const app = createApp(App)
app.use(router)
app.use(store);
app.component('font-awesome-icon', FontAwesomeIcon)

// match user system theme if no cookie stored
const theme = store.state.theme
console.log("theme in cookie:", theme)
if (!theme) {
  store.commit(
    'setTheme',
    window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
  )
} else {
  store.commit('setTheme', theme)
}


app.mount('#app')
